module.exports = __webpack_public_path__ + "static/media/3x2 L.65791b25.jpg";